import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { Observable, of } from 'rxjs';
import { HttpUtilityService } from "src/app/http/http-utility.service";
import { AppId, AwshelperApiUrl , YccDataBucket, YccLogoFolder, YccDocumentFolder, S3Region} from "src/environments/environment";


declare const InstallTrigger: any;

@Injectable()
export class FileUploadService {


  
  constructor(
    private _httpService: HttpUtilityService
  ) { }


 public uploadFiles (allcaifiles, orgguid) {
    let that = this;
    allcaifiles.forEach((caifile) => {
      caifile.error = false;
      caifile.isUploaded = false;
      caifile.isProcessed = false;
      if (caifile) {

        let metadata = {
          AWS_FILE_GUID:  caifile.AwsFileGuid,
          OrganizationGuid: orgguid,
          FileType: caifile.filetype,
          Original_File_Name: caifile.filename.trim(),
          AppID: AppId,
          FileTypeDescription: caifile.fileTypeDescription
      };
        caifile.filemetadata = metadata;
        this.uploadFileToS3(caifile, orgguid);
      }
    });    
  }

  public uploadFileToS3(file, orgId)  {
   let that = this;
    //###### Start - Check browser to set chunk size
    let chunkSize;

    let isOpera = this.isOpera();
    let isFirefox = this.isFirefox();
    let isSafari = this.isSafari();
    let isChrome = this.isChrome() && !isOpera;
    let isIE = this.isIE();

    if (isChrome) {
        chunkSize = 5 * 1024 * 1024 * 1024; //5368709120; //5 GB
    } else if (isIE) {
        chunkSize = 3 * 1024 * 1024 * 1024; //4294967296 //3 GB
    } else {
        chunkSize = 2 * 1024 * 1024 * 1024; //2 GB
    }
    //###### End - Check browser to set chunk size

    let opts = {
        queueSize: 1,
        partSize: chunkSize
    };
    let params = {
        Bucket: YccDataBucket,
        Key: orgId + '/',
        Body: file.file,
        ContentType: file.filetype,
        Metadata: file.filemetadata
    };

    if(file.fileTypeDescription == 'Logo') {
          params.Key = params.Key + YccLogoFolder + file.filename;
    } else {
      params.Key = params.Key + YccDocumentFolder + file.filename;
    }
    
this.gettempCreds()
.subscribe((result) => {
      console.log(result);
    //   const bucket = new S3(
    //   {
    //     accessKeyId: result.AccessKey,
    //     secretAccessKey: result.SecretKey,
    //     sessionToken: result.SessionToken,
    //     region: 'us-gov-west-1'
    //   }
    // );
this.getS3Bucket(result).upload(params, function (err, data) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
        return false;
      }

      console.log('Successfully uploaded file.', data);
      return true;
    });

});
  }


public gettempCreds (): Observable<any> {
    
    let data = {BucketName: YccDataBucket};
  
  let uri = AwshelperApiUrl + 'AwsTempCredentials'  ;
  return this._httpService.externalpost(uri, data);

//  .map( SearchResponseMapper.toSearchResponse , this);
  }

private getS3Bucket(creds): any {

    const bucket = new S3(
      {
       accessKeyId: creds.AccessKey,
        secretAccessKey: creds.SecretKey,
        sessionToken: creds.SessionToken,
        region: S3Region
      }
    );
    return bucket;
  }

private isOpera(): boolean {
    return (!!window['opr'] && !!window['opr'].addons) || 
    !!window['opera'] || navigator.userAgent.indexOf(' OPR/') >= 0;
}

private isFirefox(): boolean {
    //noinspection TypeScriptUnresolvedVariable
    return typeof InstallTrigger !== 'undefined';
}

private isSafari(): boolean {
    return /constructor/i.test(window['HTMLElement']) || ((p): boolean => {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || window['safari'].pushNotification);
}

private isIE(): boolean {
    return /*@cc_on!@*/false || !!window.document['documentMode'];
}

private isChrome(): boolean {
    return !!window['chrome'] && !!window['chrome'].webstore;
}



}
